module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"policyMenu.delete":"Delete","policyMenu.edit":"Edit"}}')
  delete Component.options._Ctor
}
